import { createBKOrder, getPayState } from '@/api/index.js';

/** 免费次数已满（code 201）：补考订单 + JSAPI 支付 + 轮询支付状态后执行 onPaid（正式卷传试卷 id，模拟卷 testPaperId 为 0） */
export default {
    methods: {
        buildJsapiPayArgs(data) {
            if (!data || typeof data !== 'object') return null;
            const { appId, nonceStr, packageVal, paySign, signType, timeStamp } = data;
            if (!appId || !nonceStr || !packageVal || !paySign || !signType || !timeStamp) {
                return null;
            }
            return {
                appId,
                timeStamp: String(timeStamp),
                nonceStr,
                package: packageVal,
                signType,
                paySign,
            };
        },
        invokeWxJsapiPay(payArgs) {
            return new Promise((resolve, reject) => {
                const run = () => {
                    window.WeixinJSBridge.invoke(
                        'getBrandWCPayRequest',
                        payArgs,
                        (res) => {
                            const errMsg = res.err_msg;
                            if (errMsg === 'get_brand_wcpay_request:ok') {
                                resolve();
                            } else if (errMsg === 'get_brand_wcpay_request:cancel') {
                                reject(new Error('cancel'));
                            } else {
                                reject(new Error(errMsg));
                            }
                        }
                    );
                };
                if (typeof window.WeixinJSBridge === 'undefined') {
                    document.addEventListener('WeixinJSBridgeReady', run, { once: true });
                } else {
                    run();
                }
            });
        },
        /** 与 POST /wx/getPayState 一致：仅 data === SUCCESS 视为支付完成；NOTPAY 继续轮询；REFUND/CLOSED 终止 */
        async pollPayState(outTradeNo) {
            const maxAttempts = 40;
            const intervalMs = 2000;
            const timeoutMsg = '支付结果确认超时，请稍后在「我的订单」查看或重试';
            for (let i = 0; i < maxAttempts; i++) {
                if (i > 0) {
                    await new Promise((resolve) => setTimeout(resolve, intervalMs));
                }
                let res;
                try {
                    res = await getPayState({ outTradeNo });
                } catch (err) {
                    if (err && err.code === -1001) {
                        throw err;
                    }
                    if (i === maxAttempts - 1) {
                        throw new Error(timeoutMsg);
                    }
                    continue;
                }
                if (res.code === 200 && res.data === 'SUCCESS') {
                    return;
                }
                if (res.data === 'NOTPAY') {
                    if (i === maxAttempts - 1) {
                        throw new Error(timeoutMsg);
                    }
                    continue;
                }
                if (res.data === 'REFUND') {
                    throw new Error('订单已转入退款');
                }
                if (res.data === 'CLOSED') {
                    throw new Error('订单已关闭');
                }
                if (i === maxAttempts - 1) {
                    throw new Error(timeoutMsg);
                }
            }
        },
        /**
         * @param {object} err 接口 reject 的 res（含 code、data.orderNo）
         * @param {{ testPaperId: number, onPaid: () => Promise<unknown>|void }} options
         * @returns {Promise<void>}
         */
        handleBkPayAfter201(err, options) {
            const { testPaperId, onPaid } = options;
            const orderNo = err.data?.orderNo;
            if (!orderNo) {
                return Promise.resolve();
            }
            this.$toast.clear();
            this.$toast.loading({ message: '正在发起支付...', forbidClick: true });
            return createBKOrder({ testPaperId, outTradeNo: orderNo })
                .then((orderRes) => {
                    this.$toast.clear();
                    const payArgs = this.buildJsapiPayArgs(orderRes.data);
                    if (!payArgs) {
                        this.$toast.fail('支付参数异常');
                        return Promise.reject(new Error('pay_args'));
                    }
                    return this.invokeWxJsapiPay(payArgs)
                        .then(() => {
                            this.$toast.loading({
                                message: '确认支付结果...',
                                forbidClick: true,
                            });
                            return this.pollPayState(orderNo);
                        })
                        .then(() => {
                            this.$toast.clear();
                            return onPaid();
                        })
                        .catch((e) => {
                            this.$toast.clear();
                            if (e.message !== 'cancel') {
                                this.$toast.fail(e.message);
                                return Promise.reject(e);
                            }
                            return Promise.resolve();
                        });
                })
                .catch(() => {
                    this.$toast.clear();
                });
        },
    },
};
